import { styled, Tooltip, tooltipClasses } from "@mui/material";

const StyledToolTip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#101828",
    color: "#FFFFFF",
    borderRadius: "8px",
    padding: "8px 12px",
    maxWidth: 220,
    // boxShadow: theme.shadows[2],
    ...theme.typography.body2,
    fontWeight: 600,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#101828",
  },
}));

export default StyledToolTip;